import React from "react";

export type CaFormControlProps = {
  label: string;
  children: React.ReactNode;
  id?: string;
  required?: boolean;
  error?: string;
  helperText?: string;
};

export function CaFormControl({
  label,
  children,
  id,
  required,
  error,
  helperText,
}: CaFormControlProps) {
  return (
    <div className='flex flex-col gap-1.5'>
      <label className='text-sm font-normal font-sans-serif text-deep-blue uppercase' htmlFor={id}>
        {label}
        <span className='text-red-500'>{required ? " *" : ""}</span>
      </label>
      {children}
      {helperText && <div className='text-gray-500 text-xs font-normal'>{helperText}</div>}
      {error && <div className='text-red-500 text-sm font-normal'>{error}</div>}
    </div>
  );
}

CaFormControl.defaultProps = {
  required: false,
};

export default CaFormControl;
